"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const cent_js_1 = require("cent.js");
const centrifuge_1 = __importDefault(require("centrifuge"));
const jsonwebtoken_1 = __importDefault(require("jsonwebtoken"));
const ws_1 = require("ws");
const amqplib_1 = __importDefault(require("amqplib"));
const RelayerMessenger_1 = __importDefault(require("./RelayerMessenger"));
class RelayerManagerMessenger {
    constructor(socketClientEndpoint, socketAdminEndpoint, socketAdminSecret, socketApiKey, queue) {
        this.queue = queue;
        this.socketClient = new centrifuge_1.default(socketClientEndpoint, { debug: true, websocket: ws_1.WebSocket });
        const token = jsonwebtoken_1.default.sign({ sub: 'RelayerManager' }, socketAdminSecret);
        this.socketClient.setToken(token);
        this.socketAdmin = new cent_js_1.CentClient({
            url: socketAdminEndpoint,
            token: socketApiKey,
        });
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            yield new Promise((resolve) => {
                this.socketClient.on('connect', () => {
                    resolve();
                });
                this.socketClient.connect();
            });
            const connection = yield amqplib_1.default.connect(this.queue.url);
            this.channel = yield connection.createChannel();
            this.channel.assertQueue(this.queue.name, {
                durable: true,
            });
        });
    }
    getRelayerMessenger(relayerAddress) {
        return new RelayerMessenger_1.default(relayerAddress, this.socketClient, this.socketAdmin, this.channel, this.queue.name);
    }
}
exports.default = RelayerManagerMessenger;
//# sourceMappingURL=index.js.map